import React, { useState, useEffect, useReducer, useRef } from "react";
import SelectBox from "devextreme-react/select-box";
import ScrollView from "devextreme-react/scroll-view";
import rpsReducer from "../../reducers/rps";
import * as action from "../../actions/rps";
import DateBox from "devextreme-react/date-box";
import { TextBox } from "devextreme-react";
import "../../styles/sps.css";
import Button from "devextreme-react/button";
import { TagBox } from "devextreme-react/tag-box";
import moment from "moment";
import AsyncCallHandler from "../../common/AsyncCallHandler";
import NEXUS_CONST from "../../common/constants";
import { alert } from "devextreme/ui/dialog";
import { Validator, RequiredRule } from "devextreme-react/validator";
import ValidationGroup from "devextreme-react/validation-group";
import { set } from "../../common/utils";
import { INDE } from "./config";
import { postUserLog } from "../../actions/common";
const initialStates = {
  approvers: [],
  peopleData: [],
  reasonCodes: [],
  peopleList: [],
  reasonCodeModule: [],
  moduleData: [],
};
const generalInfoInitialState = {
  startDate: new Date(),
  dueDate: new Date(Date.now() + 30 * 24 * 60 * 60 * 1000),
  areaToSolve: "",
  problemToSolve: "",
  processOwner: "",
  coach: "",
  teamMembers: [],
  newTeamMember: [],
  completedOn: new Date(),
  status: "",
  metric: "",
  subModule: "",
  metricName: "",
  subModuleName: "",
  metricID: "",
  subModuleID: "",
};

export default ({
  siteId,
  tierId,
  data,
  activeItem,
  setRPSSId,
  setisOpen,
  rpsID,
  handleSPSSave,
  navigationOn,
}) => {
  const [state, dispatch] = useReducer(rpsReducer, initialStates);
  let {
    approvers,
    reasonCodes,
    peopleData,
    peopleList,
    reasonCodeModule,
    moduleData,
  } = state;
  const [distinctUsers, setDistinctUsers] = useState([]);
  const [generalInfoData, setGeneralInfoData] = useState({
    ...generalInfoInitialState,
  });
  const [isDisabled, setIsDisabled] = useState(false);
  const [isGeneralInfoDisabled, setIsGeneralInfoDisabled] = useState(false);
  const [isCompletedDateVisible, setIsCompletedDateVisible] = useState(false);
  let [subModuleData, setSubModuleData] = useState([]);
  let [refinedModuleData, setRefinedModuleData] = useState([]);

  set("printInfoG", { approvers, peopleList, distinctUsers });
  useEffect(() => {
    let siteInfo = `&siteId=` + siteId;
    action.fetchUsers(dispatch, "tierId=" + tierId, siteInfo);
    action.getApproverHighestTier(dispatch, siteId);
    action.fetchPeopleList(dispatch, siteId);
    action.fetchModuleData(dispatch, tierId);
    if (rpsID) {
      AsyncCallHandler(NEXUS_CONST.FETCH_PS_DATA + rpsID, NEXUS_CONST.GET).then(
        (res) => {
          if (res) {
            setGeneralInfoData({
              ...generalInfoData,
              startDate: new Date(res.data.startDate),
              dueDate: new Date(res.data.dueDate),
              areaToSolve: res.data.areaToSolve.toString(),
              problemToSolve: res.data.problemToSolve,
              processOwner: res.data.processOwner.toString(),
              coach: res.data.coach.toString(),
              teamMembers: res.data.teamMembers,
              completedOn: new Date(res.data.completedOn),
              status: res.data.status,
              metric: res.data.metricID,
              subModule: res.data.subModuleID,
              metricName: res.data.metric,
              subModuleName: res.data.subModule,
              metricID: res.data.metricID,
              subModuleID: res.data.subModuleID,
            });
            if (res.data.status === "Complete") {
              setIsCompletedDateVisible(true);
            }
            setIsGeneralInfoDisabled(true);
            setIsDisabled(res?.data?.status === "Complete");

            //   action.fetchReasonCodeByFrequency(dispatch, tierId);
          }
        }
      );
    } else {
      setGeneralInfoData({
        ...generalInfoData,
        areaToSolve: data[activeItem].title,
      });
    }
  }, [rpsID]);

  useEffect(() => {
    if (moduleData) {
      setRefinedModuleData(getRefinedModuleData(moduleData));
    }
    if (generalInfoData.subModuleID > 0) {
      getFilteredSubModule(generalInfoData.metricID);
      getFilteredReasonData(
        generalInfoData.subModuleID,
        generalInfoData.metricName
      );
    } else {
      getFilteredReasonData(0, generalInfoData.metricName);
    }
  }, [generalInfoData.subModuleID, moduleData]);

  const getRefinedModuleData = (moduleData) => {
    let mapData = [];

    if (moduleData && moduleData.length > 0) {
      let i = 1;
      const uniqueMetrics = moduleData.filter(
        (metric, index, self) =>
          index === self.findIndex((m) => m.metricID === metric.metricID)
      );

      return uniqueMetrics;
    }
  };
  useEffect(() => {
    if (generalInfoData.teamMembers) {
      if (peopleData.length > 0) {
        populateDistinctUsersList();
      }
    }
  }, [generalInfoData.teamMembers, peopleData]);

  const populateDistinctUsersList = () => {
    let modifiedUsersList1 = [];
    if (
      generalInfoData?.teamMembers.length > 1 &&
      generalInfoData?.teamMembers.includes(";")
    ) {
      let _splitedData = generalInfoData?.teamMembers.split(";");
      _splitedData.length > 1
        ? _splitedData.map((collab) => modifiedUsersList1.push(collab))
        : modifiedUsersList1.push(generalInfoData?.teamMembers);

      generalInfoData.newTeamMember = modifiedUsersList1;
    } else if (generalInfoData?.teamMembers.length >= 7) {
      modifiedUsersList1 = generalInfoData?.teamMembers;
      generalInfoData.newTeamMember = modifiedUsersList1.split(" ");
    }
    let _distinctUsers = [
      ...new Map(peopleData.map((ele) => [ele["employeeID"], ele])).values(),
    ];
    setDistinctUsers([..._distinctUsers]);
  };

  const saveGeneralInfo = () => {
    let _generalInfoData = { ...generalInfoData };

    if (_generalInfoData.coach === _generalInfoData.processOwner) {
      alert("Coach and Process Owner Cannot Be The Same", "Alert");
    } else if (_generalInfoData.dueDate < _generalInfoData.startDate) {
      alert("Due Date cannot be lesser than the Start Date", "Alert");
    } else if (
      _generalInfoData.processOwner.length == 0 ||
      _generalInfoData.coach.length == 0 ||
      _generalInfoData.problemToSolve.length == 0 ||
      _generalInfoData.areaToSolve.length == 0 ||
      generalInfoData.newTeamMember.length == 0
    ) {
      alert("Please enter value in all values marked mandatory", "Alert");
    } else {
      let formData = {
        rpsid: rpsID === null ? 0 : rpsID,
        tierId: parseInt(tierId),
        processOwner: _generalInfoData.processOwner,
        coach: _generalInfoData.coach,
        startDate: moment(_generalInfoData.startDate).format("YYYY/MM/DD"),
        dueDate: moment(_generalInfoData.dueDate).format("YYYY/MM/DD"),
        areaToSolve: _generalInfoData.areaToSolve,
        problemToSolve: _generalInfoData.problemToSolve + "",
        metricID: _generalInfoData.metricID,
        subModuleID:
          _generalInfoData.subModuleID === ""
            ? 0
            : _generalInfoData.subModuleID,
        teamMembers: _generalInfoData.newTeamMember.join(";"),
        lastSavedTab: "0",
      };
      AsyncCallHandler(
        NEXUS_CONST.MANAGE_PS_DATA,
        NEXUS_CONST.POST,
        formData
      ).then((res) => {
        if (res) {
          setRPSSId(res.data);
          handleSPSSave();
          postUserLog({
            event: "Box G - General Information",
            data: {
              action: `PS-${res.data} created`,
              module: "Digital Tier",
              section: navigationOn,
              siteUId: siteId,
              widget: "Structured Problem Solving",
              tierId: tierId,
            },
          });
        }
      });
    }
    setTimeout(setisOpen("G"), 1000);
  };

  const handleInputChange = (e) => {
    let name = e.component.option("name");
    let value = e.value;

    if (e.event) {
      if (name === "coach" && value !== "") {
        setGeneralInfoData({
          ...generalInfoData,
          coach: e.value,
        });
      } else if (name === "newTeamMember" && !value.includes(";")) {
        setGeneralInfoData({
          ...generalInfoData,
          newTeamMember: e.value,
        });
      } else if (name === "startDate" && value !== "") {
        setGeneralInfoData({
          ...generalInfoData,
          startDate: e.value,
        });
      } else if (name === "metric" && value !== "") {
        getFilteredSubModule(e.value);
        let metricD = moduleData.filter((y) => {
          if (y.metricID === e.value) return y.metric;
        });
        let noSubModuleData = moduleData.filter((y) => {
          if (y.metricID === e.value && y.subModuleID === null);
        });
        setGeneralInfoData({
          ...generalInfoData,
          metricID: e.value,
          metric: e.value,
          metricName: metricD[0].metric,
        });
        if (noSubModuleData && e.value !== 4) {
          getFilteredReasonData(0, metricD[0].metric);
        }
      } else if (name === "subModule" && value !== "") {
        getFilteredReasonData(e.value, generalInfoData.metricName);
        setGeneralInfoData({
          ...generalInfoData,
          subModule: e.value,
          subModuleID: e.value,
          //   subModuleName: e.value,
        });
      } else {
        setGeneralInfoData({ ...generalInfoData, [name]: value });
      }
    } else if (name === "newTeamMember") {
      setGeneralInfoData({
        ...generalInfoData,
        newTeamMember: e.value,
      });
    }
  };
  const getFilteredSubModule = (moduleID) => {
    let mapData = [];
    if (moduleID && moduleID > 0 && moduleData.length > 0) {
      let filteredModuleData = [...moduleData];
      mapData = filteredModuleData.filter(
        (y) => y.metricID == moduleID && y.subModuleID !== null
      );
      setSubModuleData(mapData);
    }
  };

  const getFilteredReasonData = (suboduleID, metric) => {
    action.fetchReasonCodeFrequencyByModule(
      dispatch,
      `${tierId}&metric=${metric}&subModuleID=${suboduleID}`
    );
  };

  function setStateValue(rowData, value) {
    this.defaultSetCellValue(rowData, value);
  }
  return (
    <>
      <div>
        {" "}
        <h2 className="sps_title">General Information</h2>{" "}
        <div className="sps-save-btn save-btn">
          <Button
            style={{ float: "right", width: "140px", "margin-top": "3%" }}
            disabled={isDisabled}
            width={200}
            onClick={saveGeneralInfo}
            text="Save"
            type="normal"
          />
        </div>
      </div>
      <ScrollView width="100%" height="434px" className="sps-box-s">
        <ValidationGroup>
          <div className="dx-field-labelatc">
            <SelectBox
              id="processOwner"
              name="processOwner"
              labelMode={"floating"}
              items={peopleList}
              label="Process Owner*"
              onValueChanged={handleInputChange}
              value={generalInfoData?.processOwner}
              valueExpr="employeeId"
              displayExpr="employeeName"
              disabled={isGeneralInfoDisabled}
              validationMessagePosition="left"
              width={400}
            ></SelectBox>
            <SelectBox
              name="coach"
              items={approvers}
              labelMode={"floating"}
              label="Coach*"
              valueExpr="id"
              displayExpr="name"
              value={generalInfoData?.coach}
              disabled={isGeneralInfoDisabled}
              onValueChanged={handleInputChange}
              width={400}
            >
              {" "}
              <Validator>
                <RequiredRule message="Coach is required" />
              </Validator>
            </SelectBox>
          </div>
          <div className="dx-field-labelatc">
            <DateBox
              name="startDate"
              label="Start Date*"
              labelMode="floating"
              value={generalInfoData?.startDate}
              onValueChanged={handleInputChange}
              disabled={isGeneralInfoDisabled}
              type="date"
              useMaskBehavior={true}
              width={400}
            ></DateBox>
            <DateBox
              name="dueDate"
              label="Due Date*"
              labelMode="floating"
              disabled={isGeneralInfoDisabled}
              value={generalInfoData?.dueDate}
              onValueChanged={handleInputChange}
              type="date"
              useMaskBehavior={true}
              width={400}
            ></DateBox>
          </div>
          <div className="dx-field-labelatc">
            <SelectBox
              id="areaToSolve"
              name="areaToSolve"
              labelMode={"floating"}
              items={data}
              label="Area To Solve*"
              disabled={isGeneralInfoDisabled}
              value={generalInfoData?.areaToSolve}
              valueExpr="title"
              displayExpr="title"
              onValueChanged={handleInputChange}
              width={400}
            />
            <SelectBox
              id="metric"
              name="metric"
              label="Module*"
              labelMode="floating"
              searchEnabled={true}
              disabled={isGeneralInfoDisabled}
              //items={moduleData}
              items={refinedModuleData}
              valueExpr="metricID"
              value={generalInfoData?.metric}
              width={400}
              displayExpr="metricDesc"
              //onValueChanged={onStatusChanged}
              onValueChanged={handleInputChange}
            />
          </div>
          <div className="dx-field-labelatc">
            {/* <SelectBox
              id="problemToSolve"
              name="problemToSolve"
              label="Problem To Solve*"
              labelMode="floating"
              searchEnabled={true}
              disabled={isGeneralInfoDisabled}
              items={reasonCodes}
              valueExpr="code"
              value={generalInfoData?.problemToSolve}
              width={400}
              displayExpr="value"
              onValueChanged={handleInputChange}
            /> */}
            {subModuleData && subModuleData.length > 0 && (
              <SelectBox
                id="subModule"
                name="subModule"
                label="Sub Module*"
                labelMode="floating"
                searchEnabled={true}
                disabled={isGeneralInfoDisabled}
                // items={moduleData}
                items={subModuleData}
                valueExpr="subModuleID"
                value={generalInfoData?.subModule}
                width={400}
                displayExpr="subModuleName"
                onValueChanged={handleInputChange}
              />
            )}
            {generalInfoData && generalInfoData.metricName !== INDE && (
              <SelectBox
                id="problemToSolve"
                name="problemToSolve"
                label="Problem To Solve*"
                labelMode="floating"
                searchEnabled={true}
                disabled={isGeneralInfoDisabled}
                items={reasonCodeModule}
                valueExpr="reasonCodeID"
                value={+generalInfoData?.problemToSolve}
                width={400}
                displayExpr="reason"
                onValueChanged={handleInputChange}
              />
            )}
            {generalInfoData && generalInfoData.metricName === INDE && (
              <TextBox
                id="problemToSolve"
                name="problemToSolve"
                label="Problem To Solve*"
                labelMode="floating"
                disabled={isGeneralInfoDisabled}
                value={generalInfoData?.problemToSolve}
                width={400}
                onValueChanged={handleInputChange}
              />
            )}
          </div>
          <div className="dx-field-tagBox">
            {distinctUsers && (
              <TagBox
                name="newTeamMember"
                label="Team Members*"
                labelMode="floating"
                items={distinctUsers}
                onValueChanged={handleInputChange}
                valueExpr="employeeID"
                displayExpr="employeeName"
                showSelectionControls={true}
                maxDisplayedTags={6}
                searchEnabled={true}
                height={100}
                value={generalInfoData.newTeamMember}
              />
            )}
          </div>
          <div className="dx-field-tagBox">
            <DateBox
              name="completedDate"
              label="Completed Date"
              labelMode="floating"
              value={generalInfoData?.startDate}
              onValueChanged={handleInputChange}
              visible={isCompletedDateVisible}
              disabled={true}
              type="date"
              useMaskBehavior={true}
            ></DateBox>
          </div>
        </ValidationGroup>
      </ScrollView>
    </>
  );
};
